<template>
  <div class="page-hero">
    <v-row>
      <v-col
        class="center my-8 py-8"
        cols="12"
        lg="10"
      >
        <h1 class="page-hero-title text-center">
          {{ title }}
        </h1>
        <div class="page-hero-line" />
        <v-row
          v-if="intro || hasSlotContent"
          justify="center"
        >
          <v-col
            cols="12"
            :lg="introLg"
          >
            <slot>
              <p class="page-hero-intro text-center">
                {{ intro }}
              </p>
            </slot>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'PageHero',
  props: {
    title: {
      type: String,
      required: true,
    },
    intro: {
      type: String,
      default: '',
    },
    introLg: {
      type: String,
      default: '6',
    },
  },
  computed: {
    hasSlotContent() {
      return !!this.$slots.default
    },
  },
}
</script>
